<template>
  <div>
    <!--    <el-popover-->
    <!--        placement="top-start"-->
    <!--        :width="340"-->
    <!--        trigger="hover"-->
    <!--        :open-delay="700"-->

    <!--    >-->
    <!--      <User-Infor-Card :data="curent_data" type="small" @opendialog="$refs.dialog.isLogin()">-->
    <!--      </User-Infor-Card>-->
    <!--      <template #reference>-->
    <div class="d-flex hot-blogger bg-white" id="author" :class="{noborder:type=='small'}">
      <div :class="{'hot-blogger-avatar':type=='default','small':type=='small'}">
        <div v-if="$store.state.user.check_is_wxcblog_domain() || $store.state.user.check_is_wxcblog_domain()">
          <a :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+data.userinfo_userID.username">
            <div style="position:relative">
              <icon-V style="transform: rotate(34deg);" class="text-primary lable"
                      v-if="curent_data.userinfo_userID.is_hot_blogger"></icon-V>
            </div>
            <div v-if="!curent_data.userinfo_userID.avatar" class="avatar-word">
              {{ curent_data.userinfo_userID.first_letter }}
            </div>
            <img
                v-if="curent_data.userinfo_userID.avatar"
                v-bind:alt="curent_data.userinfo_userID.username"
                class="rounded-circle"
                v-bind:src="curent_data.userinfo_userID.avatar">
          </a>
        </div>
        <router-link
            v-else
            :to="'/blog/user/'+curent_data.userID">
          <div style="position:relative">
            <icon-V style="transform: rotate(34deg);" class="text-primary lable"
                    v-if="curent_data.userinfo_userID.is_hot_blogger"></icon-V>
          </div>
          <div v-if="!curent_data.userinfo_userID.avatar" class="avatar-word">
            {{ curent_data.userinfo_userID.first_letter }}
          </div>
          <img
              v-if="curent_data.userinfo_userID.avatar"
              v-bind:alt="curent_data.userinfo_userID.username"
              class="rounded-circle"
              v-bind:src="curent_data.userinfo_userID.avatar"
          >
        </router-link>
      </div>
      <div  class='align-self-center right pl-2 flex-grow-1'>
        <div class="d-flex align-self-center justify-content-between">
          <div :class="{'blogger-name':type=='default','small-name':type=='small'}">
            <router-link :to="'/blog/user/'+curent_data.userID">
              <span v-if="usertype!=='search'">{{ curent_data.userinfo_userID.username | textTrans }}</span>
              <span v-if="usertype==='search'" class="text-muted">
                  <span v-html="curent_data.username" style="color:#14171a;"></span>
                  <span style="font-size:24px;font-weight:300;padding:0 14px">|</span>博客名：<span
                  v-html="curent_data.name"></span>
                </span>
            </router-link>
            <el-tooltip effect="light" :content="getCountryName()" placement="top" visible-arrow="false">
              <a style="font-size:15px;margin-left:1px;text-decoration: none;cursor: pointer">{{
                  curent_data.userinfo_userID.country_flag.flag
                }}</a>
            </el-tooltip>
          </div>
          <div v-if="!$store.state.user.check_is_wxcblog_domain()">
            <a  v-if="!curent_data.userinfo_userID.is_following" class="btn btn-link text-primary w-100 btn-follow"
               @click="following_add(curent_data.userID)">
              <div class="d-flex justify-content-end align-items-center add">
                <icon-plus></icon-plus>
                {{ $t('message').blog.blogger_follow }}
              </div>
            </a>
            <a v-if="curent_data.userinfo_userID.is_following" class="btn btn-link text-default w-100 cancel-follow"
               @click="following_delete(curent_data.userID)">
                  <span class="cancel-text text-danger">
                      <div class="d-flex justify-content-end align-items-center">
                        <icon-x :style="{fill:'#FF3636'}"></icon-x>
                        {{ $t('message').blog.blogger_remove_follow }}
                      </div>
                  </span>
              <span class="followed-text text-default">
                      <div class="d-flex justify-content-end align-items-center" style="fill:#999">
                          <icon-check></icon-check>
                          {{ $t('message').blog.blogger_followed }}
                      </div>
                  </span>
            </a>
          </div>
        </div>
        <!--            <div id="description" class="description" :title="curent_data.description">-->
        <!--              {{ curent_data.description }}-->
        <!--            </div>-->
      </div>
    </div>
    <!--      </template>-->
    <login-dialog ref="dialog"></login-dialog>
    <!--    </el-popover>-->
  </div>
</template>
<script>
import {IconCheck, IconPlus, IconV, IconX} from '@/components/Icons';
import {Button,} from '@/components';
import account from '../../../../user/user.service';
import LoginDialog from '../../../../user/login/LoginDialog';
import {textTrans} from '@/directives/textTrans.js';

export default {
  name: 'bloger-list-item',
  props: {
    type: {
      type: String,
      default: 'default',
      description: 'Alert type'
    },
    data: {
      userID: Number,
      count_follower: Number,
      count_buzz: Number,
      count_article: Number,
      count_comment: Number,
      count_read: Number,
      description: String,
      userinfo_userID: {
        id: Number,
        username: String,
        avatar: String,
        description: String,
        verified: Number,
        status: Number,
        first_letter: String,
        is_hot_blogger: Number,
        is_following: Number
      }
    },
    usertype: String
  },
  components: {
    [Button.name]: Button,
    IconPlus,
    IconCheck,
    IconX,
    IconV,
    LoginDialog,
    // UserInforCard
  },
  filters: {
    textTrans(string) {
      return textTrans(string);
    }
  },
  created: function () {
    let userinfor = this.$store.state.user.userinfo;
    this.loginuserID = userinfor ? userinfor.UserID : -1;
    if (this.usertype == "follower") {
      this.curent_data.userinfo_userID = this.data.userinfo_followerID;
      this.curent_data.userID = this.data.userinfo_followerID.id;
    }
  },

  methods: {
    following_add(id) {
      if (!this.check_user_login()) return;
      account.following_add(id).then(res => {
        if (res.status) {
          this.curent_data.userinfo_userID.is_following = 1;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    getCountryName() {
      return localStorage.lang === 'cns' ? this.curent_data.userinfo_userID.country_flag.cns : this.curent_data.userinfo_userID.country_flag.cnt
    },
    following_delete(id) {
      if (!this.check_user_login()) return;
      account.following_delete(id).then(res => {
        if (res.data == true) {
          this.curent_data.userinfo_userID.is_following = 0;
        } else {
          this.$message.error(res.error);
        }
      });
    },
  },
  data() {
    return {
      loginuserID: -1,
      error: '',
      curent_data: this.data,
    }
  },

  watch: {
    data(val) {
      this.curent_data = val
    }
  }
}

</script>
<style>

.hot-blogger {
  padding: 12px 18px;
  border-top: 1px solid #ebeef0;
}

.hot-blogger.noborder {
  border-top: 0;
}

.hot-blogger a {
  color: #14171a;
  text-decoration: none;
  display:inline-flex;
  /*display: inline-block;*/
}

.hot-blogger a:hover {
  color: #235592
}

.hot-blogger .description a {
  color: #657786
}

.hot-blogger-avatar .avatar-word, .small .avatar-word {
  border-radius: 50%;
  background-color: #eeeeee;
  line-height: 48px;
  text-align: center;
  font-weight: 500;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset
}

.hot-blogger-avatar .avatar-word, .small .avatar-word:hover {
  background-color: #eeeeee;
}

.hot-blogger-avatar .avatar-word {
  min-width: 48px
}

.hot-blogger .small .lable {
  position: absolute;
  margin-left: 20px;
  margin-top: -14px;
  transform: rotate(33deg)
}

.hot-blogger-avatar .lable {
  position: absolute;
  margin-left: 28px;
  margin-top: -14px;
  transform: rotate(27deg)
}

.hot-blogger-avatar {
  width: 48px;
  height: 48px

}

.hot-blogger-avatar .rounded-circle, .hot-blogger-avatar .avatar-word:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}

.small {
  width: 36px;
}

.hot-blogger-avatar img {
  width: 48px;
  height: 48px;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset;

}

.small img {
  width: 36px;
  height: 36px;
}

.small .avatar-word {
  width: 38px;
  height: 38px;
  line-height: 38px;
  font-size: 1rem;
}

.blogger-name {
  font-size: 1rem;
  font-weight: 600;

}

.blogger-name span {
  color: #333
}

.small-name {
  font-size: .95rem;
  font-weight: 600;

}

.cancel-follow span.cancel-text, .cancel-follow:hover span.followed-text {
  display: none;
}

.cancel-follow span.followed-text, .cancel-follow:hover span.cancel-text {
  display: block;
}

.cancel-follow, .btn-follow {
  padding: 0;
}

.hot-blogger .right a {
  padding: 0;
}

.hot-blogger .right .btn {
  margin: 0;
}

.hot-blogger .right .btn .add {
  fill: #35abbb;
  font-size: 1rem;
  /* border-radius: 20px;
  padding: 3px 13px; */
}

.hot-blogger .right .btn:hover .add {
  fill: #236e85;
}

.hot-blogger .right .description {
  font-size: medium;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: 4px;
}

.el-popover.bubble {
  background-color: #14171a;
  color: white
}

.el-popover.bubble .popper__arrow,
.el-popover.bubble .popper__arrow::after {
  border-top-color: #14171a;
  border-bottom-color: #14171a;
}

.el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after {
  display: none;
}

.el-tooltip__popper, .tooltip-inner {
  min-width: 32px !important;
}

@media (max-width: 575.98px) {
  .list-itme .list-itme-image {
    margin: auto 0;
    margin-left: .5rem;
  }

  .imgspace {
    width: 90px;
    height: 90px;
  }

  .hot-blogger {
    padding: 12px 0;
  }

  .hot-blogger .right .description {
    display: none;
  }

  .cancel-follow span.cancel-text.text-danger {
    display: block;
    color: #888 !important;
  }

  .cancel-follow span.followed-text {
    display: none;
  }
}
</style>
